import { Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { PaneHeader } from "./PaneHeader";

export function ProjectLoadingPane() {
  const { t } = useTranslation("ui");
  return (
    <div className="flex h-full flex-col border-l border-puntt-accent-6/20 bg-puntt-neutral-gray-1">
      {/* Header — shares the canonical PaneHeader height so the loading
          skeleton's title bar lines up with the ProjectStatusPane it is
          replaced by once the project finishes loading. */}
      <PaneHeader
        region="project"
        leading={
          <div className="size-2.5 shrink-0 animate-pulse rounded-full bg-puntt-accent-9 ring-2 ring-puntt-accent-4" />
        }
        title={
          <span className="truncate text-[13px] font-semibold normal-case tracking-normal text-puntt-neutral-gray-12">
            {t("projectLoadingPane.settingUpProject")}
          </span>
        }
      />

      {/* Skeleton content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="space-y-6">
          {/* Project name skeleton */}
          <div className="h-6 w-3/5 animate-pulse rounded bg-puntt-neutral-gray-4" />

          {/* Type + markets skeleton */}
          <Flex gap="3">
            <div className="h-4 w-24 animate-pulse rounded bg-puntt-neutral-gray-4" />
            <div className="h-4 w-16 animate-pulse rounded bg-puntt-neutral-gray-4" />
          </Flex>

          {/* Stage progress bars skeleton */}
          <div className="space-y-2">
            <div className="h-3 w-20 animate-pulse rounded bg-puntt-neutral-gray-4" />
            <Flex gap="1">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="h-2.5 flex-1 animate-pulse rounded-full bg-puntt-neutral-gray-4"
                />
              ))}
            </Flex>
          </div>

          {/* Routing table skeleton */}
          <div className="space-y-3">
            <div className="h-3 w-16 animate-pulse rounded bg-puntt-neutral-gray-4" />
            {[...Array(3)].map((_, i) => (
              <Flex key={i} align="center" gap="3">
                <div className="size-8 animate-pulse rounded-full bg-puntt-neutral-gray-4" />
                <div className="h-4 w-32 animate-pulse rounded bg-puntt-neutral-gray-4" />
                <div className="h-4 w-20 animate-pulse rounded bg-puntt-neutral-gray-4" />
              </Flex>
            ))}
          </div>

          {/* Forecast metrics skeleton */}
          <Flex gap="4">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="flex-1 rounded-lg border border-puntt-neutral-gray-6 p-3"
              >
                <div className="h-3 w-16 animate-pulse rounded bg-puntt-neutral-gray-4" />
                <Text
                  size="5"
                  weight="bold"
                  className="mt-2 block text-puntt-neutral-gray-5"
                >
                  --
                </Text>
              </div>
            ))}
          </Flex>
        </div>
      </div>
    </div>
  );
}
